import React from "react";

const CrauselBanner = () => {
  return (
    <div
      id="heroCarousel"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
      data-bs-interval="3000"
      data-bs-pause="false"
    >
      {/* INDICATORS */}
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        />
        <button
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        />
      </div>

      <div className="carousel-inner">
        {/* SLIDE 1 */}
        <div className="carousel-item active">
          <img 
            src="s1.png" 
            className="d-block w-100" 
            alt="Fresh Fruits"
            style={{ height: "75vh", objectFit: "cover" }}
          />
          <div className="carousel-caption d-flex flex-column align-items-start justify-content-center h-100 top-0 start-0 text-start p-5" style={{ background: "rgba(0,0,0,0.4)", left: 0, right: 0, bottom: 0 }}>
            <div className="container">
              <h1 className="display-4 fw-bold mb-3">Premium Indian Fruits</h1>
              <p className="fs-5 mb-4 w-50">Direct from farm to world</p>
              <div>
                <a href="/produce" className="btn btn-success btn-lg px-4 me-3">Products</a>
                <a href="/contactus" className="btn btn-outline-light btn-lg px-4">Contact</a>
              </div>
            </div>
          </div>
        </div>

        {/* SLIDE 2 */}
        <div className="carousel-item">
          <img 
            src="s2.png"  
            className="d-block w-100" 
            alt="Global Export"
            style={{ height: "75vh", objectFit: "cover" }}
          />
          <div className="carousel-caption d-flex flex-column align-items-start justify-content-center h-100 top-0 start-0 text-start p-5" style={{ background: "rgba(0,0,0,0.4)", left: 0, right: 0, bottom: 0 }}>
            <div className="container">
              <h1 className="display-4 fw-bold mb-3">Global Export Partner</h1>
              <p className="fs-5 mb-4 w-50">Serving 15+ countries worldwide</p>
              <div>
                <a href="/produce" className="btn btn-success btn-lg px-4 me-3">Products</a>
                <a href="/contactus" className="btn btn-outline-light btn-lg px-4">Contact</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CONTROLS */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>

      <style>{`
        .carousel-caption {
          bottom: 0;
          right: 0;
          left: 0;
        }
        .carousel-item {
          transition: transform 0.8s ease-in-out;
        }
        
        /* Mobile responsive height */
        @media (max-width: 768px) {
          .carousel-item img {
            height: 50vh !important;
          }
          .carousel-caption {
            padding: 1rem !important;
          }
          .carousel-caption h1 {
            font-size: 1.8rem;
          }
          .carousel-caption p {
            font-size: 1rem;
            width: 100% !important;
          }
          .btn {
            padding: 0.5rem 1rem !important;
            font-size: 0.9rem !important;
          }
        }
        
        @media (max-width: 576px) {
          .carousel-item img {
            height: 40vh !important;
          }
          .carousel-caption h1 {
            font-size: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default CrauselBanner;